import { useCustomerDetails } from '@egw/api'
import { Field, ModalDrawer } from '@egw/components'
import { useTranslation } from '@egw/i18n'
import { type FC, useState } from 'react'
import { formatPhoneNumberString } from '../../utils'
import { UpdatePhone } from './update-phone'

export const EditPhoneField: FC = () => {
  const { t } = useTranslation('features-settings')
  const [openEdit, setOpenEdit] = useState<boolean>(false)
  const [modalTitle, setModalTitle] = useState<string>(t('personal_info.change_mobile_phone'))

  const { data } = useCustomerDetails()

  const phone = data?.customer.phone

  const phoneNumber = phone ? `+${phone.countryPhoneCode}${phone.phoneNumber}` : undefined

  const phoneNumberStr = phoneNumber ? formatPhoneNumberString(phoneNumber) : undefined

  return phoneNumberStr ? (
    <>
      <Field
        valueClassName="font-light"
        className="w-full justify-between border-list mb-0 py-4 px-2"
        onEdit={() => {
          setOpenEdit(true)
        }}
        value={phoneNumberStr}
        isPII
      />
      <ModalDrawer
        title={modalTitle}
        isOpen={openEdit}
        onClose={() => {
          setOpenEdit(false)
        }}
      >
        <UpdatePhone
          setModalTitle={setModalTitle}
          closeModal={() => {
            setOpenEdit(false)
          }}
        />
      </ModalDrawer>
    </>
  ) : null
}
